import { Component, OnInit } from "@angular/core";
import { NgRedux } from "@shared/redux/redux-compatibility.service";
import { AppState } from "@shared/redux/store";
import { CommonService } from "@shared/services/common.service";
import { Report } from "@shared/models/user.model";
import { SharedService } from "@shared/services/shared.service";
import { CatService } from "@shared/services/cat.service";


@Component({
    selector: 'app-mng-reports',
    templateUrl: './mng-reports.component.html',
    styleUrls: ['./mng-reports.component.scss'],
    standalone: false
})
export class MngReportComponent implements OnInit {
    showEditReportModal: boolean;

    constructor(private ngRedux: NgRedux<AppState>,
        private commonService: CommonService,
        private catService: CatService,
        private sharedService: SharedService
        
    ) { }
    reportsList: Report[] = [];
    loading = false;
    reportToSave: Report | null = null;

    ngOnInit(): void {
        // Initialization logic here
        this.loading = true;
        const envId = this.ngRedux.getState().curEnv?.id;
        this.commonService.getReportsList(envId).subscribe(
            reports => {
                
                this.reportsList = reports;
                this.loading = false;
            }, 
            error => {
                console.error('Error fetching reports:', error);
                this.loading = false;
            }
        );
    }

    formatDate(date: Date): string {

            if (date == null) {
                return '';
            }
                
            const utcDate = new Date(date); // UTC date

            const formatted = utcDate.toLocaleString(undefined, {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: 'numeric',
            minute: '2-digit',
            hour12: true,       // AM/PM
            });
            return formatted;
    }
    formatDateOnly(date: Date): string {

            if (date == null) {
                return '';
            }
            const utcDate = new Date(date); // UTC date

            const formatted = utcDate.toLocaleDateString(undefined, {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric'
            });
            return formatted;
    }

    download(report: Report) {
        // Logic to download the report

        // create URL and open in new tab
        this.catService.getS3Objects([report.reportLocation]).subscribe(
            s3Objects => {
                if (s3Objects) {
                    // get key of entry report.reportLocation
                    const url = s3Objects.get(report.reportLocation);
                    // download file to local system
                    fetch(url)
                        .then(response => {
                            if (!response.ok) {
                                throw new Error('Download failed');
                            }
                            return response.blob();
                        })
                        .then(blob => {
                            const blobUrl = window.URL.createObjectURL(blob);

                            const a = document.createElement('a');
                            a.href = blobUrl;
                            a.download = report.reportName || 'report';

                            document.body.appendChild(a);
                            a.click();
                            document.body.removeChild(a);

                            window.URL.revokeObjectURL(blobUrl);
                        })
                        .catch(err =>  {
                            console.error(err);
                            this.sharedService.showInfoMessage({
                                infoType: 'error',
                                messageKey: 'Error downloading report.',
                                titleKey: 'Download Error',
                            });
                        });
                }
            }
        );
    }

    addReport() {
        
        this.showEditReportModal = true;
        this.reportToSave = new Report();

    }

    savedReport(report: Report) {
        
        this.reportsList.unshift(report);
        this.showEditReportModal = false;
        this.reportToSave = null;

    }
}